import { NotificationScope } from "@/shared/common/enums";
import type { TNotificationScope } from "@/shared/common/types";
import type { TAlertTypes } from "@ab.uitools/ui-library/components/Alert/types";
import type { TSnackbarTypes } from "@ab.uitools/ui-library/components/Snackbar/types";
import { createSlice } from "@reduxjs/toolkit";


export interface ISnackbarNotification {
  message: string;
  type: TSnackbarTypes;
}

export interface IAlertNotification {
  message: string;
  scope?: TNotificationScope;
  type: TAlertTypes;
}

interface InitialState {
  alertNotification?: IAlertNotification;
  snackbarNotification?: ISnackbarNotification;
}

const initialState: InitialState = {
  alertNotification: {} as IAlertNotification,
  snackbarNotification: {} as ISnackbarNotification,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setAlertNotification: (state, { payload }: { payload: IAlertNotification }) => {
      const scope = payload.message ? payload.scope || NotificationScope.Page : "";
      state.alertNotification = { ...payload, scope };
    },
    setSnackbarNotification: (state, { payload }: { payload: ISnackbarNotification }) => {
      state.snackbarNotification = payload || {};
    },
  },
});

export const {
  setAlertNotification,
  setSnackbarNotification,
} = notificationSlice.actions;
export default notificationSlice.reducer;
